import { GetModelPoIsQuery, ModelPoiFragmentFragment } from "generated/graphql";
import { Cluster } from "./clusterType";

export enum POIType {
    POI = "POI",
    LINE_TAP = "LINE_TAP"
}

export interface ModelPOI {
    id: string;
    poi: string;
    poiName: string;
    poiType: POIType;
    cluster: Cluster;
    area: string;
    voltage: number;
    deleted: boolean;
}

export const convertHasuraModelPOItoModelPOI = (
    hasuraData: ModelPoiFragmentFragment,
    cluster: Cluster
): ModelPOI => {
    return {
        id: hasuraData.id,
        poi: hasuraData.poi,
        poiName: hasuraData.poi_name,
        poiType: hasuraData.poi_type as POIType,
        cluster,
        area: hasuraData.area,
        voltage: Number(hasuraData.voltage),
        deleted: hasuraData.deleted
    };
};

export const convertHasuraModelPOIstoModelPOIs = (
    hasuraData: GetModelPoIsQuery,
    cluster: Cluster
): ModelPOI[] => {
    return hasuraData.in_queue_model_pois.map((hasuraModelPOI) =>
        convertHasuraModelPOItoModelPOI(hasuraModelPOI, cluster)
    );
};
